import { BarChartRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { GroupByField } from './GroupByField';

export function QuantifyFeedbackFieldGroup() {
  return (
    <Stack direction="column" spacing={1.5} px={2} py={1.5}>
      <Stack direction="row" spacing={1} alignItems="center">
        <BarChartRounded
          sx={{
            color: 'text.secondary',
          }}
        />
        <Typography variant="subtitle1">Plot</Typography>
      </Stack>
      <Box pl={4}>
        <GroupByField />
      </Box>
    </Stack>
  );
}
